import { useState } from "react";
import { throwResponseError } from "../../../utils/api-error-utils";
import { getAuthParams } from "../../../utils/pacto-rebates-utils";
import { formatAdjustmentResponse } from "../../utils/adjustment-utils";

export function useAdjustmentById() {
	const [adjustment, setAdjustment] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);

	async function fetchAdjustmentById(adjustmentId) {
		if (!adjustmentId) {
			setAdjustment(null);
			setError("Não foi possível identificar o reajuste.");

			return {
				ok: false,
				reason: "validation",
				error: "Não foi possível identificar o reajuste."
			};
		}

		try {
			setLoading(true);
			setError(null);

			const {
				accessToken,
				clientId
			} = getAuthParams();

			const requestOptions = {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"access_token": accessToken,
					"client_id": clientId
				}
			};

			const response = await fetch(
				process.env.REACT_APP_ESSILOR_API +
					`pacto-rebates-admin/v1/reajustes/${encodeURIComponent(adjustmentId)}`,
				requestOptions
			);

			if (!response.ok) {
				await throwResponseError(
					response,
					"Não foi possível carregar os dados do reajuste."
				);
			}

			const data = await response.json();

			const adjustmentData = Array.isArray(data.resultado)
				? data.resultado[0]
				: data.resultado || data;

			const formattedAdjustment = formatAdjustmentResponse(adjustmentData);

			setAdjustment(formattedAdjustment);

			return {
				ok: true,
				adjustment: formattedAdjustment
			};
		} catch (requestError) {
			setAdjustment(null);
			setError(requestError.message);

			return {
				ok: false,
				reason: "request",
				error: requestError.message
			};
		} finally {
			setLoading(false);
		}
	}

	return {
		adjustment,
		loading,
		error,
		fetchAdjustmentById
	};
}